import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getAttributes = createAsyncThunk(
  "attribute/getAttributes",
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/all-attributes?search=${data.search}&filter=${data.filter}&perPage=${data.perPage}&page=${data.page}`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to get attributes.");
    }
  }
);

export const addAttribute = createAsyncThunk(
  "attribute/addAttribute",
  async (data, { rejectWithValue }) => {
    try {
      let url = "admin/attributes";
        if (data.id) {
        url += `/${data.id}`;
      }
      const response = await api.post(url, data);

      return response;
    } catch (err) {
      const action = data.id ? "update" : "add";
      return rejectWithValue(err.response?.data || `Failed to ${action} attribute`);
    }
  }
);

export const deleteAttribute = createAsyncThunk(
  "attribute/deleteAttribute",
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.del(`admin/attributes/${id}`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete attribute");
    }
  }
);

export const changeAttributeStatus = createAsyncThunk(
  "attribute/changeAttributeStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await api.post(`admin/attribute/change-status/${id}`, { status });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to change status");
    }
  }
);

export const downloadAttributesCsv = createAsyncThunk(
  "attribute/downloadAttributesCsv",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`admin/export-attributes`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to export attributes");
    }
  }
);

const attributeSlice = createSlice({
  name: "attribute",
  initialState: {
    list_attribute: [],   
    selected: null, 
    loading: false,
    list_loading: false,
    status: "idle",
  },
  reducers: {
    setSelectedAttribute(state, action) {
      state.selected = action.payload; 
    },
    unsetSelectedAttribute(state) {
      state.selected = null; 
    },
    resetStatus(state) {
      state.loading = false;
      state.list_loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAttributes.pending, (state) => {
        state.list_loading = true;
      })
      .addCase(getAttributes.fulfilled, (state, action) => {
        state.list_loading = false;
        state.list_attribute = action.payload;
      })
      .addCase(getAttributes.rejected, (state) => {
        state.list_loading = false;
      })
      .addCase(addAttribute.pending, (state) => {
        state.loading = true;
      })
      .addCase(addAttribute.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addAttribute.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteAttribute.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAttribute.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAttribute.rejected, (state) => {
          state.loading = false;
      })
      .addCase(changeAttributeStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeAttributeStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changeAttributeStatus.rejected, (state) => {
        state.loading = false;
      })
      .addCase(downloadAttributesCsv.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadAttributesCsv.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadAttributesCsv.rejected, (state) => {
        state.loading = false;
      });  
  },
});

export const { setSelectedAttribute, unsetSelectedAttribute, resetStatus } = attributeSlice.actions;
export default attributeSlice.reducer;
